export const tooltipText =
  'Novos status podem ser apresentados conforme o\nprogresso da ordem, por exemplo: ORDEM REJEITADA.';
